"use strict";

import angular from "angular";

const name = "step";
const factory = function stepFilter() {
    return function (input) {
        const inputs = {
            email: "Próximo",
            password: "Acessar",
            passwordRecover: "Enviar",
            emailSent: "Acessar conta"
        };
        return inputs[input];
    };
};
angular.module("nucont.shared").filter(name, factory);
export default { name, factory };
